import Vue from 'vue'
import VueRouter from 'vue-router'
import DashboardLayout from '@/pages/Dashboard/Layout/DashboardLayout.vue'
import Crops from '@/pages/Crops.vue'
import Regions from '@/pages/Regions.vue'
import Comparative from '@/pages/Comparative.vue'
import Prices from '@/pages/Prices.vue'
import Boards from '@/pages/Boards.vue'
import Questions from '@/pages/Questions.vue'
import Home from '@/pages/Home.vue'
import Upload from '@/pages/Upload.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    children: [
      {
        path: '/',
        components: {default: Home}
        
      },
      {
        path: '/regiones',
        components: {default: Regions}
        
      },
      {
        path: 'comparativa',
        components: {default: Comparative},
        
      },
      {
        path: 'cultivos',
        components: {default: Crops},
        
      },
      {
        path: 'precios',
        components: {default: Prices},
        
      },
      {
        path: 'ganaderia',
        components: {default: Boards},
        
      },
      {
        path: 'preguntas-frecuentes',
        components: {default: Questions},
        
      },
      {
        path: 'upload',
        components: {default: Upload},
        
      },
    ]
  }
]

// configure router
export default new VueRouter({
  routes, // short for routes: routes
  //mode: 'history',
  //base: 'test',
  linkExactActiveClass: 'nav-item active'
})








